import { render, staticRenderFns } from "./SelectSearchUnderwriter.vue?vue&type=template&id=0860dd8c"
import script from "./SelectSearchUnderwriter.vue?vue&type=script&lang=ts"
export * from "./SelectSearchUnderwriter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports